import { colors, Icon, IconButton } from '@neshane/blueberry';

import { toggleForceToExpandNavigation } from '../NavigationContext';

import './Logo.css';

export const Logo = () => {
  return (
    <div className="ml-4 flex items-center justify-between">
      {/* <Icon
        name="spendesk"
        color={colors.contentPrimary}
        aria-hidden="true"
        size="l"
        className="ml-4 shrink-0"
      /> */}
      <img src='/media/logo.png' width={32} />
      <IconButton
        className="navigation-toggle-display text-primary"
        iconName="left-menu"
        aria-label="باز و بسته کردن ناوبری"
        onClick={() => {
          toggleForceToExpandNavigation();
        }}
      />
    </div>
  );
};